export default __webpack_public_path__ + "static/TaskMaster-3a4586c7954bca9e4f7905666b5bbe28.png";